import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./growerBatchCreate.css";
import {
  GET_LAND_DETAILS_FROM_REGISTRATION_MODULE,
  GET_USER_DETAILS,
  RescScmAdminMember,
} from "../../../common/URLs";
import jwt from "jwt-decode";
import "bootstrap/dist/css/bootstrap.min.css";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD, NO_DATA_AVAILABLE } from "../../../common/constants";
import {
  Container,
  Stack,
  Box,
  Typography,
  Grid,
  Button,
  Paper,
  Divider,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import apiClient from "../../../axios";
import BackButton from "../../../common/backButton";

function GrowerBatchCreate() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [emailId, setEmailId] = useState("");
  const [userDetails, setUserDetails] = useState(null);

  const [urn, setUrn] = useState("");
  const [allLandDetails, setAllLandDetails] = useState(null);
  const [selectedLand, setSelectedLand] = useState(null);
  const [selectedUrn, setSelectedUrn] = useState("");

  const checkUserDetails = localStorage.getItem("role");

  useEffect(() => {
    const token = getLocalStorageItem("id_token");
    if (token) {
      const decoded = jwt(token);
      const email = decoded.emails?.[0] || "";
      setEmailId(email);
    }
  }, []);

  useEffect(() => {
    if (emailId) {
      getUserDetails();
    }
  }, [emailId]);

  const getUserDetails = () => {
    apiClient
      .post(
        GET_USER_DETAILS,
        {
          emailAddress: emailId,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setUserDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setSelectedUrn(location?.state?.data?.urn || "");
  }, [location?.state?.data?.urn]);

  useEffect(() => {
    const token = getLocalStorageItem("id_token");
    if (token) {
      const decoded = jwt(token);
      if (decoded.extension_URN) {
        setUrn(decoded.extension_URN);
      }
    }
  }, []);

  useEffect(() => {
    if (urn || selectedUrn) {
      getLandDetails();
    }
  }, [urn, selectedUrn]);

  const getLandDetails = () => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_LAND_DETAILS_FROM_REGISTRATION_MODULE,
        {
          urn: urn ? urn : selectedUrn,
          allFlag: "null",
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setAllLandDetails(response.data);
        loaderService.hideLoader();
      })
      .catch((error) => {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const plantationRows = useMemo(() => {
    return allLandDetails?.plantationBatchPojo || [];
  }, [allLandDetails]);

  const handleChange = (selectedItem) => {
    setSelectedLand(selectedItem);
  };

  const onSubmit = () => {
    const userData = {
      selectedLand: selectedLand,
      selectedUrn: selectedUrn,
    };

    if (!selectedLand) {
      toast.error("Please select a land");
    } else {
      if (RescScmAdminMember.includes(checkUserDetails)) {
        navigate("plantationSponsored", {
          state: {
            landName: userData?.selectedLand?.landName,
            landId: userData?.selectedLand?.landId,
            possibleClumpsToGrow: userData?.selectedLand?.possibleClumpsToGrow,
            urn: allLandDetails?.plantationBatchPojo?.[0]?.urn,
            growerName: allLandDetails?.plantationBatchPojo?.[0]?.growerName,
            growerType: allLandDetails?.plantationBatchPojo?.[0]?.growerType,
            availableLandArea: userData?.selectedLand?.availableLandArea,
            landArea: userData?.selectedLand?.landArea,
            state: allLandDetails?.plantationBatchPojo?.[0]?.state,
            district: allLandDetails?.plantationBatchPojo?.[0]?.district,
          },
        });
      } else {
        navigate("addPlantationbatch", {
          state: {
            landName: userData?.selectedLand?.landName,
            landId: userData?.selectedLand?.landId,
            possibleClumpsToGrow: userData?.selectedLand?.possibleClumpsToGrow,
            urn: allLandDetails?.plantationBatchPojo?.[0]?.urn,
            growerName: allLandDetails?.plantationBatchPojo?.[0]?.growerName,
            growerType: allLandDetails?.plantationBatchPojo?.[0]?.growerType,
            availableLandArea: userData?.selectedLand?.availableLandArea,
            landArea: userData?.selectedLand?.landArea,
            state: allLandDetails?.plantationBatchPojo?.[0]?.state,
            district: allLandDetails?.plantationBatchPojo?.[0]?.district,
          },
        });
      }
    }
  };

  const growerbatchcol = [
    {
      field: "checkbox",
      headerName: "",
      width: 70,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isDisabled =
          allLandDetails?.isApprovedStakeholder === "N" ||
          params.row.landAvailableFlag === "N";

        return (
          <input
            type="radio"
            name="landName"
            disabled={isDisabled}
            checked={selectedLand?.landId === params?.row?.landId}
            onChange={() => handleChange(params?.row)}
            style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          />
        );
      },
    },
    {
      field: "landName",
      headerName: t("reg.landName"),
      flex: 1,
      minWidth: 150,
    },
    {
      field: "pincode",
      headerName: t("preReg.pincode"),
      flex: 0.8,
      minWidth: 110,
    },
    {
      field: "address",
      headerName: t("main.address"),
      flex: 1.3,
      minWidth: 180,
    },
    {
      field: "district",
      headerName: t("preReg.district"),
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "state",
      headerName: t("preReg.state"),
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "landArea",
      headerName: t("resource.existingLandArea(in Bigha)"),
      flex: 1,
      minWidth: 180,
    },
    {
      field: "availableLandArea",
      headerName: t("resource.availableLandArea(in Bigha)"),
      flex: 1,
      minWidth: 190,
    },
  ];

  const growerInfo = plantationRows?.[0];

  return (
    <Container maxWidth="xl" sx={{ py: 1.5 }}>
      {!PROD && <p className="pageNumberingResc">RES21</p>}

      {allLandDetails && (
        <Box>
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: 2,
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <Box sx={{ px: 2, py: 1.5 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
                flexWrap="wrap"
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <BackButton navigate={navigate} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t("resource.selectLandToCreatePlantation")}
                  </Typography>
                </Stack>

                {allLandDetails?.isApprovedStakeholder === "N" && (
                  <Chip
                    label="Stakeholder Not Approved"
                    size="small"
                    color="warning"
                    variant="outlined"
                  />
                )}
              </Stack>
            </Box>

            <Divider />

            <Box
              sx={{
                px: 2,
                py: 1.25,
                backgroundColor: "#fafbfc",
                borderBottom: "1px solid #eceff3",
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" color="text.secondary">
                    {t("resource.growerURN")}
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {growerInfo?.urn || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" color="text.secondary">
                    {t("resource.growerName")}
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {growerInfo?.growerName || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ p: 1.25 }}>
              <Box
                sx={{
                  height: 360,
                  width: "100%",
                  "& .MuiDataGrid-root": {
                    border: "1px solid #edf1f5",
                    borderRadius: 1.5,
                    fontSize: "0.88rem",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f7f8fa",
                    borderBottom: "1px solid #e8edf2",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 600,
                  },
                  "& .MuiDataGrid-cell": {
                    borderColor: "#f1f3f6",
                    py: 0.5,
                  },
                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#fafcff",
                  },
                }}
              >
                {plantationRows.length > 0 ? (
                  <DataGrid
                    rows={plantationRows}
                    columns={growerbatchcol}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    getRowId={(row) => row?.landId}
                    disableSelectionOnClick
                  />
                ) : (
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px dashed #d7dde5",
                      borderRadius: 1.5,
                    }}
                  >
                    <Typography sx={{ fontWeight: 600 }}>
                      {NO_DATA_AVAILABLE}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            <Divider />

            <Box sx={{ px: 2, py: 1.25 }}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "stretch", sm: "center" }}
                justifyContent="space-between"
                spacing={1.5}
              >
                <Typography variant="body2" color="text.secondary">
                  Selected Land:{" "}
                  <Box component="span" sx={{ color: "#111827", fontWeight: 600 }}>
                    {selectedLand?.landName || "None"}
                  </Box>
                </Typography>

                <Button
                  variant="contained"
                  onClick={onSubmit}
                  sx={{
                    minWidth: 110,
                    textTransform: "none",
                    fontWeight: 600,
                  }}
                >
                  {t("preReg.next")}
                </Button>
              </Stack>
            </Box>
          </Paper>
        </Box>
      )}
    </Container>
  );
}

export default GrowerBatchCreate;